module.exports = __webpack_public_path__ + "static/media/_title_13.b385bb53.svg";